export default __webpack_public_path__ + "static/dropdownPlayStore-baf23743b542ba49583a9fc47cd5a869.png";